export default __webpack_public_path__ + "static/annam-880cd1f7df5c17a834873489f777e5e5.jpg";